// extracted by mini-css-extract-plugin
module.exports = {"root":"StyleButton__root--1TjP4","active":"StyleButton__active--3wCxL","disabled":"StyleButton__disabled--2FrCn"};